import { useEffect } from 'react';
import * as React from 'react';
import SecuredPage from 'Views/Components/Security/SecuredPage';

import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';
import CustomerAccountPage from 'Modules/UserAccount/Components/CustomerAccountPage';
import { ACCOUNT_CUSTOMER_PAGE_TITLE } from 'ConstantPageNames';

function AccountDetailsPage() {
	useEffect(() => {
		document.title = ACCOUNT_CUSTOMER_PAGE_TITLE;
	}, []);

	return (
		<SecuredPage
			groups={['Super Administrators', 'User', 'Staff', 'Manager', 'Admin', 'InvoicedUser', 'FixedPriceUser']}
		>
			<NavigationWrapper />
			<div className="body-content">
				<CustomerAccountPage />
			</div>
		</SecuredPage>
	);
}

export default AccountDetailsPage;
